import axios from 'axios'
import { requestInterceptor, responseInterceptor } from './interceptor'
import { API, API_MIPE, NODE_ENV } from '@/config'

export const api = axios.create({
  baseURL: API.BASE_URL,
  timeout: NODE_ENV === 'production' ? API.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export const apiMipe = axios.create({
  baseURL: API_MIPE.BASE_URL,
  timeout: NODE_ENV === 'production' ? API.TIMEOUT : undefined,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(
  requestInterceptor.onFulfilled,
  requestInterceptor.onRejected
)

api.interceptors.response.use(
  responseInterceptor.onFulfilled,
  responseInterceptor.onRejected
)

apiMipe.interceptors.request.use(
  requestInterceptor.onFulfilled,
  requestInterceptor.onRejected
)

apiMipe.interceptors.response.use(
  responseInterceptor.onFulfilled,
  responseInterceptor.onRejected
)
